import { Tag } from "@/models/Tag";
import PaginatedResponse from "@/models/PaginatedResponse";

export const TagRequest = (argTag) => {
  let tag = argTag.copy();

  if (!tag.id) {
    delete tag.id;
  }

  return tag;
};

export const TagResponse = (tag) => {
  return new Tag(tag);
};

export const TagsResponse = (tags) => {
  return tags.map((p) => TagResponse(p));
};

export const PaginatedTagsResponse = (data) => {
  let response = new PaginatedResponse(data);
  response.results = response.results.map((i) => TagResponse(i));
  return response;
};